import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';

 const NotFound = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sayfa Bulunamadı."
      extra={
        <Link to="/">
          <Button type="primary">Genel Görünüme Dön</Button>
        </Link>
      }
    />
  );
};

export default NotFound;
